module.exports = "<div class=public><public-header is-auth=$ctrl.isAuth></public-header><div class=\"d-flex flex-column public__wrapper\"><div ui-view class=public__view></div><gmc-footer></gmc-footer></div></div>";


//////////////////
// WEBPACK FOOTER
// ./app/states/public/public.component.html
// module id = 960
// module chunks = 31